import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { CoreBox } from '@youscience/core';

import { sxStyles, StyledTaskCardWrap, StyledTaskCardInner } from './TaskCard.styles';

export const TaskCardSkeleton = () => {
  return (
    <StyledTaskCardWrap>
      <StyledTaskCardInner>
        <Stack spacing={3} direction="row">
          <Skeleton variant="rounded" width={20} height={20} />

          <Skeleton variant="rounded" width="100%" height={20} />
        </Stack>

        <Stack spacing={1} direction="column" marginTop={6}>
          <Skeleton variant="rounded" width="100%" height={22} />

          <Skeleton variant="rounded" width="100%" height={22} />

          <Skeleton variant="rounded" width="75%" height={22} />
        </Stack>

        <CoreBox sx={sxStyles.cardFooter}>
          <Skeleton variant="rounded" width="100%" height={32} />
        </CoreBox>
      </StyledTaskCardInner>
    </StyledTaskCardWrap>
  );
};
